import React, { useEffect, useState } from "react";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "../lib/SupabaseClient";

export default function SocialAuthModal() {
    const [open, setOpen] = useState(false);

    // ✅ Global event to trigger login modal
    useEffect(() => {
        const handler = () => setOpen(true);
        window.addEventListener("open-social-login", handler);
        return () => window.removeEventListener("open-social-login", handler);
    }, []);

    if (!open) return null;

    return (
        <div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[3000]
                       flex justify-center items-center md:items-start md:pt-[10vh] 
                       overflow-y-auto p-4"
            onClick={() => setOpen(false)}
        >
            <div
                className="w-full max-w-sm bg-neutral-950 border border-neutral-800 
                           rounded-2xl p-5 shadow-2xl transform transition-all"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex items-center justify-between mb-3">
                    <h3 className="text-lg font-semibold text-neutral-100">Sign in</h3>
                    <button
                        onClick={() => setOpen(false)}
                        className="text-neutral-400 hover:text-neutral-200"
                    >
                        ✕
                    </button>
                </div>

                {/* Supabase Auth UI */}
                <Auth
                    supabaseClient={supabase}
                    providers={["google", "facebook"]}
                    socialLayout="horizontal"
                    redirectTo={window.location.origin} // ✅ dynamically return to same origin
                    appearance={{
                        theme: ThemeSupa,
                        variables: {
                            default: {
                                colors: {
                                    brand: "#4F46E5",
                                    brandAccent: "#6366F1",
                                    inputBackground: "#FFFFFF",
                                },
                                radii: {
                                    inputBorderRadius: "6px",
                                    buttonBorderRadius: "6px",
                                },
                            },
                        },
                    }}
                />


                {/* Cancel */}
                <div className="mt-4 text-center">
                    <button
                        onClick={() => setOpen(false)}
                        className="px-4 py-2 rounded-xl border border-neutral-700 
                                   text-neutral-300 text-sm hover:bg-neutral-800 transition"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}
